import React from "react";
import { useSurveyUrl } from "./utils/surveyUrl";

const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_c41ac942-b289-4e5b-a0c4-9845a8b228fb/artifacts/hsq2iw0w_Asset%2010%404x-8.png";
const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_c41ac942-b289-4e5b-a0c4-9845a8b228fb/artifacts/mw1vpqkw_Asset%208%404x-8.png";

const FONT = "'Inter', -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif";

const LandingPageB = () => {
  const SURVEY_URL = useSurveyUrl();
  return (
    <div className="min-h-screen bg-white md:bg-[#0F172A]" style={{ fontFamily: FONT }} data-testid="landing-page-b">

      <section
        className="min-h-screen flex flex-col items-center justify-center px-8 py-16 md:py-24"
        data-testid="hero-section-b"
      >
        <div
          className="w-full max-w-[520px] md:max-w-[680px] md:bg-white md:rounded-[16px] md:px-16 md:py-16 md:shadow-[0_10px_30px_rgba(0,0,0,0.08)]"
          data-testid="content-block"
        >

          {/* Logo */}
          <div className="mb-12 md:mb-16" data-testid="logo-header-b">
            <img src={LOGO_BLACK} alt="HAEVN" style={{ height: 28 }} />
          </div>

          {/* Headline */}
          <h1
            className="text-[#111] text-[34px] md:text-[46px] leading-[1.15] mb-3 md:mb-2.5"
            style={{ fontWeight: 700, letterSpacing: "-0.02em" }}
            data-testid="headline-primary"
          >
            No one needs another dating app.
          </h1>

          {/* Subline */}
          <p
            className="text-[#666] text-[19px] md:text-[21px] leading-[1.4] mb-8 md:mb-7"
            style={{ fontWeight: 400 }}
            data-testid="headline-secondary"
          >
            That's why we built HAEVN.
          </p>

          {/* Divider */}
          <div className="h-px bg-[#E5E7EB] mb-10 md:mb-8" data-testid="divider" />

          {/* Anchor line */}
          <p
            className="text-[#111] text-[21px] md:text-[22px] leading-[1.4] mb-9 md:mb-7"
            style={{ fontWeight: 600 }}
            data-testid="accent-line"
          >
            It works like a recruiter for your love life.
          </p>

          {/* Body 1 */}
          <p
            className="text-[#222] text-[17px] md:text-[18px] leading-[1.5] mb-8 md:mb-6"
            style={{ fontWeight: 400 }}
            data-testid="block-how"
          >
            You tell us what you're looking for.<br />
            We find people who actually match.
          </p>

          {/* Emphasis 1 */}
          <p
            className="text-[#111] text-[17px] md:text-[18px] leading-[1.5] mb-8 md:mb-6"
            style={{ fontWeight: 600 }}
            data-testid="block-no-noise"
          >
            No swiping. No chasing. No noise.
          </p>

          {/* Emphasis 2 — payoff line */}
          <p
            className="text-[#111] text-[19px] md:text-[21px] leading-[1.5] mb-8 md:mb-6"
            style={{ fontWeight: 700 }}
            data-testid="block-text-you"
          >
            When there's a match, we text you.
          </p>

          {/* Body 2 */}
          <p
            className="text-[#222] text-[16px] md:text-[17px] leading-[1.5] mb-10 md:mb-8"
            style={{ fontWeight: 400 }}
            data-testid="block-pricing"
          >
            You don't pay anything unless you decide to connect.
          </p>

          {/* Time Block */}
          <div className="mb-8 md:mb-6" data-testid="block-time">
            <p className="text-[#111] text-[21px] md:text-[22px] leading-[1.3] mb-2" style={{ fontWeight: 700 }}>
              10–15 minutes.
            </p>
            <p className="text-[#111] text-[17px] md:text-[18px] leading-[1.4]" style={{ fontWeight: 600 }}>
              That's all it takes to find real matches.
            </p>
          </div>

          {/* Decision line */}
          <p
            className="text-[#111] text-[15px] md:text-[16px] leading-[1.5] mb-7 md:mb-6"
            style={{ fontWeight: 500 }}
            data-testid="block-decision"
          >
            You define what you want once. Then you're done.
          </p>

          {/* CTA */}
          <div data-testid="cta-block">
            <a
              href={SURVEY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full md:w-[460px] text-center text-white"
              style={{
                height: 56,
                lineHeight: "56px",
                borderRadius: 8,
                backgroundColor: "#D89B00",
                fontSize: 16,
                fontWeight: 700,
                marginBottom: 12,
                textDecoration: "none",
                transition: "background-color 0.2s",
                border: "1px solid #B88400",
                boxShadow: "inset 0 1px 0 rgba(255,255,255,0.15)",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#B88400")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#D89B00")}
              data-testid="main-cta-b"
            >
              Start your survey
            </a>
            <p
              className="text-[#666] text-[13px] md:w-[460px]"
              style={{ fontWeight: 400 }}
              data-testid="cta-microcopy"
            >
              Private. No browsing. No spam.
            </p>
          </div>

        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#111] md:bg-[#0A0F1A]" style={{ padding: "48px 24px", fontFamily: FONT }}>
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <img src={LOGO_WHITE} alt="HAEVN" style={{ height: 28 }} />
          <p style={{ fontSize: 14, color: "#666666" }}>
            &copy; {new Date().getFullYear()} HAEVN. All rights reserved.
          </p>
        </div>
      </footer>

    </div>
  );
};

export default LandingPageB;
